import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCardWalletBulk = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.25 9.623a.3.3 0 0 1-.3.3H4.05a.3.3 0 0 1-.3-.3V8.01a3.574 3.574 0 0 1 3.57-3.57h9.36a3.574 3.574 0 0 1 3.57 3.57zM16.68 2.94H7.32a5.075 5.075 0 0 0-5.07 5.07v7.98a5.076 5.076 0 0 0 5.07 5.072h9.36a5.06 5.06 0 0 0 4.244-2.314l.07-.035v-.093c.47-.768.756-1.663.756-2.63V8.01a5.075 5.075 0 0 0-5.07-5.07"
      clipRule="evenodd"
      opacity={0.4}
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.999 5.765A688 688 0 0 0 6.377 8.72c-.168.108-.09.367.11.367h10.488a.3.3 0 0 0 .255-.46l-1.036-1.65a3.777 3.777 0 0 0-5.195-1.21"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M14.397 14.824a1.585 1.585 0 1 0 3.173 0 1.586 1.586 0 0 0-3.174 0"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCardWalletBulk);
export default ForwardRef;
